import api from "./index";

export const postValidateToken = async () => {
  try {
    const response = await api.post("api/users/platform/validate", {});
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getTokenValid = async () => {
  try {
    const response = await api.get("api/users/non/auth/tokens/validate");

    return response.data;
  } catch (error) {
    console.error("토큰 유효성 확인 실패:", error);
    throw error;
  }
};

export const postLogin = async (userName, password) => {
  // try {
  //   const response = await api.post("api/users/non/auth/tokens", {
  //     userName,
  //     password,
  //   });
  //   return response.data;
  // } catch (error) {
  //   throw error;
  // }
  try {
    // 디버깅용: 로그인 시 어떤 URL 로 요청을 보내는지 확인
    // 런타임 환경변수 (window._env_) 또는 빌드 시점 값 (process.env) 사용

    // const baseURL =
    //   window._env_?.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL;
    // const path = "api/test/jwt/generate"; // 현재 postLogin 이 사용하는 상대 경로
    // const fullUrl = `${baseURL?.replace(/\/$/, "")}/${path}`;

    const response = await api.post("api/test/jwt/generate", {
      platformId: "00000000-0000-0000-0000-000000000001",
      company: "주식회사 지태그",
      expirationMinutes: 2880,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const postRegister = async (userData) => {
  try {
    const { email, password, confirmPassword, name, phone, company } = userData;
    const data = {
      user: {
        userName: email,
        password,
        fullName: name,
        phone: phone,
        requireTerm: true,
      },
      companyId: company,
    };
    const response = await api.post("api/users/non", data);

    return response.data;
  } catch (error) {
    console.error("회원가입 실패:", error);
    throw error;
  }
};

export const getCompanyList = async () => {
  try {
    const response = await api.get("api/companies");
    return response.data;
  } catch (error) {
    console.error("회사 목록 조회 실패:", error);
    throw error;
  }
};

export const getCheckEmail = async (email) => {
  try {
    const response = await api.get(`api/users/non/auth/${email}`);
    return response.data;
  } catch (error) {
    console.error("이메일 중복확인 실패:", error);
    throw error;
  }
};

export const findPassword = async (email) => {
  try {
    const response = await api.get(`/api/users/non/auth/password/${email}`);
    return response.data;
  } catch (error) {
    console.error("비밀번호 재설정 실패:", error);
    throw error;
  }
};

export const resetPassword = async (password, token) => {
  try {
    const tokenResponse = await api.get(
      `/api/users/non/auth/password/validate/?token=${token}`,
      {
        skipAuthToken: true, // 커스텀 플래그
      }
    );

    if (tokenResponse.data.success) {
      const response = await api.post(
        `/api/users/non/auth/password`,
        {
          newPassword: password,
        },
        {
          skipAuthToken: true,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } else {
      throw new Error("토큰이 유효하지 않습니다.");
    }
  } catch (error) {
    console.error("비밀번호 재설정 실패:", error);
    throw error;
  }
};

export const requestCompany = async (companyData) => {
  const requestData = {
    name: companyData.companyName,
    description: companyData.job,
    businessNumber: companyData.businessNumber,
    address: companyData.companyAddress,
    phone: companyData.companyNumber,
    email: companyData.companyEmail,
  };
  try {
    const response = await api.post(`/api/companies`, requestData);
    return response.data;
  } catch (error) {
    console.error("기관/기업명 추가 요청 실패:", error);
    throw error;
  }
};

export const getAdminData = async (tab) => {
  try {
    let response;
    switch (tab) {
      case "member-approval":
        response = await api.get(`/api/users/admin/users?status=3`);
        break;
      case "company-approval":
        response = await api.get(`/api/companies/admin/status?status=3`);
        break;
      case "member-management":
        response = await api.get(`/api/users/admin/users`);
        break;
      case "company-management":
        response = await api.get(`/api/companies/admin/status`);
        break;
    }
    return response.data;
  } catch (error) {
    console.error("관리자 데이터 조회 실패:", error);
    throw error;
  }
};

export const ChangeMemberStatus = async (userName, status) => {
  const data = {
    userName,
    status,
  };

  try {
    const response = await api.post(`/api/users/admin/status`, data);
    return response.data;
  } catch (error) {
    console.error("회원 승인 실패:", error);
    throw error;
  }
};

export const ChangeCompanyStatus = async (companyId, status) => {
  const data = {
    companyId,
    status,
  };

  try {
    const response = await api.post(`/api/companies/admin/status`, data);
    return response.data;
  } catch (error) {
    console.error("기업 승인 실패:", error);
    throw error;
  }
};
